import { render, staticRenderFns } from "./addressFrom.vue?vue&type=template&id=22c789b4&"
import script from "./addressFrom.vue?vue&type=script&lang=js&"
export * from "./addressFrom.vue?vue&type=script&lang=js&"
import style0 from "./addressFrom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports